module.exports = __webpack_public_path__ + "static/media/logout.c63c2758.png";